// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"b809001c","250":"3e9b1b7c","351":"8a4ef70a","465":"e41efdb5","466":"30abe7ac","520":"76135925","662":"0935ad02","766":"668c5b77","773":"428027cc"}[chunkId] + ".chunk.css";
};